import { createTheme } from '@mui/material/styles';

// Define a theme object
const theme = createTheme({
  palette: {
    primary: {
      main: '#62BB46', // Using #62BB46 as primary color
    },
    secondary: {
      main: '#232E83', // Using #232E83 as secondary color
    },
    background: {
        default: '#FFFFFF',
        paper: '#FFFFFF'
    }
    // You can also add other shades such as light and dark if needed
  },
  // Other theme customizations such as typography, spacing, etc.
});

export default theme;
